import type { ReactElement } from "react"
import { useParams } from "react-router"
import { DetailPage } from "~/features/detail/components/DetailPage"
import { useEventDetail } from "../api/useEventDetail"

/**
 * The same treatment as the study detail screen. `digitalEventByID` answers with
 * either a `SimulcastEvent` or an `OnDemandEvent`; the projection flattens both
 * into the shared view, so the page does not care which arrived.
 */
export const EventDetailPage = (): ReactElement => {
  const { id } = useParams()
  const { view, isLoading, isError } = useEventDetail(id)

  return (
    <DetailPage
      view={view}
      isLoading={isLoading}
      isError={isError}
      sessionsTitle="All Sessions"
      emptySessionsMessage="This event has no sessions available on demand yet."
      errorMessage="We couldn't load this event right now."
      notFoundMessage="We couldn't find that event in your library."
      qaHook="event-detail"
    />
  )
}
